import React, { useState, useRef, useMemo } from "react";
import ReactQuill, { Quill } from "react-quill";
import { editorFontSizes } from "constants/constants";

// configure Quill to use inline styles so the email's format properly
import ImageResize from "quill-image-resize-module-react";
Quill.register("modules/imageResize", ImageResize);

var DirectionAttribute = Quill.import("attributors/attribute/direction");
Quill.register(DirectionAttribute, true);

var AlignClass = Quill.import("attributors/class/align");
Quill.register(AlignClass, true);

var BackgroundClass = Quill.import("attributors/class/background");
Quill.register(BackgroundClass, true);

var ColorClass = Quill.import("attributors/class/color");
Quill.register(ColorClass, true);

var DirectionClass = Quill.import("attributors/class/direction");
Quill.register(DirectionClass, true);

var FontClass = Quill.import("attributors/class/font");
Quill.register(FontClass, true);

var SizeClass = Quill.import("attributors/class/size");
Quill.register(SizeClass, true);

var AlignStyle = Quill.import("attributors/style/align");
Quill.register(AlignStyle, true);

var BackgroundStyle = Quill.import("attributors/style/background");
Quill.register(BackgroundStyle, true);

var ColorStyle = Quill.import("attributors/style/color");
Quill.register(ColorStyle, true);

var DirectionStyle = Quill.import("attributors/style/direction");
Quill.register(DirectionStyle, true);

var FontStyle = Quill.import("attributors/style/font");
Quill.register(FontStyle, true);

const FontSize = Quill.import("formats/size");
Quill.register(FontSize, true);

const Size = Quill.import("attributors/style/size");
Size.whitelist = editorFontSizes;
Quill.register(Size, true);

const Icons = Quill.import("ui/icons");
// undo icon
Icons["undo"] = `<svg viewbox="0 0 18 18">
<polygon class="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10"></polygon>
<path class="ql-stroke" d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"></path>
</svg>`;
// redo icon
Icons["redo"] = `<svg viewbox="0 0 18 18">
<polygon class="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10"></polygon>
<path class="ql-stroke" d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"></path>
</svg>`;
Quill.register(Icons, true);
import "react-quill/dist/quill.snow.css";

const TextEditor = ({ name, setFieldValue, addImage = true, ...rest }) => {
  const ref = useRef(null);
  const [editorHtml, setEditorHtml] = useState(rest?.value ? rest?.value : "");

  const module = useMemo(() => {
    let options = {
      toolbar: {
        container: [
          [{ size: editorFontSizes }],
          [{ font: [] }],
          [{ align: [] }],
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
          ["link"],
          [{ color: [] }, { background: [] }],
          ["undo", "redo"],
          ["clean"],
        ],
        handlers: {
          undo: () => {
            let myEditor = ref.current?.getEditor();
            return myEditor?.history?.undo();
          },
          redo: () => {
            let myEditor = ref.current?.getEditor();
            return myEditor?.history?.redo();
          },
        },
      },
      history: {
        delay: 1000,
        maxStack: 100,
        userOnly: false,
      },
      clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: false,
      },
      imageResize: {
        parchment: Quill.import("parchment"),
        modules: ["Resize", "DisplaySize", "Toolbar"],
      },
    };

    if (addImage) {
      options.toolbar.container.splice(7, 0, ["image"]);
    }

    return options;
  }, []);

  const onChange = html => {
    setEditorHtml(html);
    setFieldValue(name, html);
  };

  return (
    <ReactQuill
      // {...rest}
      theme='snow'
      ref={ref && ref}
      onChange={onChange}
      value={editorHtml}
      modules={module}
      formats={[
        "size",
        "font",
        "align",
        "bold",
        "italic",
        "underline",
        "strike",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "color",
        "background",
        "undo",
        "redo",
        "clean",
      ]}
      placeholder='Write something here...'
    />
  );
};

export default React.memo(TextEditor);
